/**
 * Error messages that stay until the merchant closes them (Built for Shopify 4.2.4: no errors in toasts that
 * disappear on their own). `showError` from anywhere; the page's `<ErrorBanner />` shows the latest one.
 */
export const ERROR_EVENT = 'unboxugc:error';

export function showError(message: string) {
  window.dispatchEvent(new CustomEvent<string>(ERROR_EVENT, { detail: message }));
}
